import React, { useState } from "react";
import { Upload, Button, message } from "antd";
import { InboxOutlined, UploadOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const ExcelUploader = ({
  onUpload,
  accept = ".xlsx,.xls",
  maxSize = 5,
  showDragger = true,
  buttonText = "Upload File",
  uploadText = "Click or drag file to upload",
  hintText = "Support for Excel files only"
}) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const props = {
    accept,
    multiple: false,
    fileList,
    beforeUpload: (file) => {
      // Check file type
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                      file.type === 'application/vnd.ms-excel' ||
                      file.name.endsWith('.xlsx') ||
                      file.name.endsWith('.xls');

      if (!isExcel) {
        message.error('You can only upload Excel files!');
        return Upload.LIST_IGNORE;
      }

      // Check file size (in MB)
      const isLessThanMax = file.size / 1024 / 1024 < maxSize;
      if (!isLessThanMax) {
        message.error(`File must be smaller than ${maxSize}MB!`);
        return Upload.LIST_IGNORE;
      }

      setFileList([file]);
      return false; // Prevent automatic upload
    },
    onRemove: () => {
      setFileList([]);
    },
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.warning('Please select a file first!');
      return;
    }

    setUploading(true);
    try {
      await onUpload(fileList[0]);
      setFileList([]);
      message.success('File uploaded successfully!');
    } catch (error) {
      console.error('Upload error:', error);
      message.error('Upload failed!');
    } finally {
      setUploading(false);
    }
  };

  if (showDragger) {
    return (
      <div>
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{uploadText}</p>
          <p className="ant-upload-hint">{hintText}</p>
        </Dragger>
        {fileList.length > 0 && (
          <Button
            type="primary"
            onClick={handleUpload}
            loading={uploading}
            style={{ marginTop: 16 }}
            block
          >
            {uploading ? 'Uploading...' : 'Start Upload'}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div>
      <Upload {...props}>
        <Button icon={<UploadOutlined />}>{buttonText}</Button>
      </Upload>
      {fileList.length > 0 && (
        <Button
          type="primary"
          onClick={handleUpload}
          loading={uploading}
          style={{ marginTop: 16 }}
        >
          {uploading ? 'Uploading...' : 'Start Upload'}
        </Button>
      )}
    </div>
  );
};

export default ExcelUploader;
